import { render, staticRenderFns } from "./AuthStepupRootComponent.vue?vue&type=template&id=151e763c&scoped=true"
import script from "./AuthStepupRootComponent.vue?vue&type=script&lang=js"
export * from "./AuthStepupRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151e763c",
  null
  
)

export default component.exports